<template>
    <div style="background-color: #fff;">
        <!-- COMPONENTE QUE GERA O LOADING EFECT -->
        <v-overlay :value="overlay || $store.state.loading_pdf">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

        <!--==== CONTAINER VENDAS ====-->

        <div class="flex flex-col">
            <div class="flex-1 bg-white shadow-xl">
                <!--====== COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
                <div class="header-table">
                    <div class="combo_box_container">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" rounded
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs"
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                                <v-btn text color="primary" @click="salvarData()"> OK </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                    <v-btn v-if="vendas.length && funcaoPorROle.verificarFuncao(16)" small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                </div>
                <!--====== FIM COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->

                <!-- ===== INÍCIO DA TABELA ==== -->
                <div class="main_table_container">
                    <table class="table-full">
                        <thead class="bg-gray100">
                            <tr>
                                <th class="table_head">#</th>
                                <th class="table_head">Meios de recebimento</th>
                                <th class="table_head">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(venda, index) in vendas" :key="index" v-if="vendas.length">
                                <td class="table_data"> {{ ++index }}</td>
                                <td class="table_data">
                                    <span class="color-table-data">{{ venda.descricao }}</span>
                                </td>

                                <td class="table_data">
                                    <span>{{ utilitarios.IntegerToMoneyValueFatura(venda.total) }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div  class="semPagamentos" v-if="!vendas.length">
                        <p>Dados não encontrado!</p>
                    </div>
                </div>
                <!-- ===== FIM DA TABELA ==== -->

                <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
                <div class="totaisContainer" v-if="vendas.length">
                    <div>
                        <span class="align-totais">Total Iliquido:</span>
                        <span class="text-bold totais-font-size"> {{utilitarios.IntegerToMoneyValueFatura(totaisObject.iliquido) }}</span>
                    </div>
                    <div>
                        <span class="align-totais">Total Pago</span>
                        <span class="text-bold totais-font-size"> {{utilitarios.IntegerToMoneyValueFatura(totaisObject.total) }}</span>
                    </div>
                </div>
                <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
            </div>
        </div>
    </div>
</template>
    
<script>
import _axios from '../../plugins/axios';
import utilitarios from '../../plugins/utilitarios';
import impressaoService from '../../services/impressaoService';
import funcaoPorROle from '../../utilitarios/funcao.untilitario'
import Swal from 'sweetalert2';
const ls = require('local-storage');
export default {
    name: 'listarVendas',
    data: () => ({
        utilitarios: utilitarios,
        funcaoPorROle: funcaoPorROle,
        vendas: [],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        config: null,
        baseUrl: '',
        templateFull: null
    }),

    computed: {
        licencaExpirada() {
            return ls.get('licencaExpirada')
        },
        totaisObject() {
            let totais = { iliquido: 0, total: 0}
            this.vendas.forEach(element => {
                totais.iliquido += (element.iliquido === 'N/A' || element.iliquido === null || element.iliquido === undefined) ? 0 : utilitarios.MoneyValueToInteger(element.iliquido)
                totais.total += (element.total === 'N/A') ? 0 : utilitarios.MoneyValueToInteger(element.total)
            });
            return totais
        }
    },

    created() {
        this.config = ls.get('configuracaoinstituicao');
        this.getUrlImpressao(); 
        this.pesquisarVendas();
        this.getTemplateRelatorio();
    },

    methods: {
       async getUrlImpressao() {
            this.overlay = true;
            try {
                this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro processando o servidor de impreção', 'error');
            } finally {
                this.overlay = false;
            }
        },

        async getTemplateRelatorio() {
            try {
                this.overlay = true;
                this.templateFull = await _axios.get('/obterRelatorioByDescricao/fg').then((res) => res.data[0]);
            } catch (error) {
                utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do pdf do relatório!');
            } finally {
                this.overlay = false;
            }
        },

        async pesquisarVendas() {
            try {
                this.overlay = true;
                this.vendas = await _axios.get(`/listarVendasGeral/${this.date}`).then((res) => res.data);
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro durante a listagem dos pagamentos!', 'error');
            } finally {
                this.overlay = false;
            }
        },

        salvarData() {
            this.$refs.menu.save(this.date)
            this.pesquisarVendas()
        },

        gerarHTML() {
            if (this.licencaExpirada) {
                Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
            } else {
                try {
                    this.$store.state.loading_pdf = true;

                    let template = this.templateFull.documento;
                    let relatorioDados = '';

                    this.vendas.forEach(element => {
                        let interacao1 = this.templateFull.documentoiteracao1;
                        interacao1 = interacao1.replace('{{descricao}}', element.descricao);
                        interacao1 = interacao1.replace('{{totalOperacao}}', this.utilitarios.IntegerToMoneyValueFatura(element.total));
                        relatorioDados += interacao1;
                    })

                    let dadoss = {
                        '{{instituicao}}': this.config.nome,
                        '{{data}}': this.date,
                        '{{dataActual}}': this.data_hora(),
                        '{{totalIliquido}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.iliquido),
                        '{{total}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.total),
                        '{{author}}': ls.get('nomeUsuario'),
                        '{{dados}}' : relatorioDados
                    }

                    const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
                    template = template.replace(expressaoRegular, (match) => dadoss[match]);
    
                    let options = {
                        'format': 'A4',
                        'border': {'right': '9mm', 'left': '9mm'},
                        'header': {'height': '10mm'},
                        'footer': {'height': '1mm'}
                    }
    
                    impressaoService.htmlToPdf(template, options);
                } catch (error) {
                    this.$store.state.loading_pdf = false;
                    Swal.fire('Erro', 'Ocorreu um erro durante a impressão', 'error');
                }
            }
        },
        data_hora() {
            let data = new Date()
            return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
        }
    }
};
</script>
  
<style scoped>
.combo_box_container {
    display: flex;
    justify-content: space-between;
    width: 250px;
}

.header-table {
    display: flex;
    justify-content: space-between;
    padding: 5px 50px 5px 5px;
}

.table_data {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 1px solid #e2e8f0;
    font-size: 0.75rem;
}

.table_head {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.bg-gray100 {
  background-color: #f3f4f6;
}
.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}

.align-totais {
  margin-left: 15px;
}

.text-bold {
  font-weight: bold;
}

.totais-font-size {
  font-size: 17px;
}

.semPagamentos {
    font-weight: bold;
    text-align: center; 
    height: 30px;
    font-size: 13px;
}

.semPagamentos p {
    line-height: 30px;
}
.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}
</style>